import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth.context";
import { HeaderProfileMenu } from "./HeaderProfileMenu";

export const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <header className="header">
      <div className="header-content">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <span className="header-brand">I N A R I</span>
        </a>

        <div className="header-right">
          <HeaderProfileMenu
            onLogout={() => {
              logout();
              navigate("/");
            }}
          />
        </div>
      </div>
    </header>
  );
};
